import { render, staticRenderFns } from "./report_purchase.vue?vue&type=template&id=3a16233b&scoped=true"
import script from "./report_purchase.vue?vue&type=script&lang=js"
export * from "./report_purchase.vue?vue&type=script&lang=js"
import style0 from "./report_purchase.vue?vue&type=style&index=0&id=3a16233b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a16233b",
  null
  
)

export default component.exports